import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setAll = (state, { allGroup }) => {
  if (!allGroup) return state;
  return state.merge({ allGroup });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setAllFactoryGroups = (state, { factoryGroups }) => {
  if (!factoryGroups) return false;
  return state.merge({ factoryGroups });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ALL,
    actionFunction: setAll,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_ALL_BY_FACTORY_ID,
    actionFunction: setAllFactoryGroups,
  },
];
